module.exports = __webpack_public_path__ + "media/images/statue-cfa8e9f05a2f87de0e6eed5a675def90.png";